import { ClubMember } from "../models/club-member";
import { User } from "../models/user";

export const PLUGIN_EVENTS = {
    REGISTRATION_SUCCESS: "club-plugin-registration-success",
    LOGIN_SUCCESS: "club-plugin-login-success",
    SHOW_LOGIN_POPUP: "club-plugin-show-login-popup",
} as const;

export type PluginEventMap = {
    [PLUGIN_EVENTS.REGISTRATION_SUCCESS]: ClubMember;
    [PLUGIN_EVENTS.LOGIN_SUCCESS]: User | null;
    [PLUGIN_EVENTS.SHOW_LOGIN_POPUP]: void;
};

export function emitEvent<K extends keyof PluginEventMap>(type: K, detail?: PluginEventMap[K]) {
    window.dispatchEvent(new CustomEvent(type, { detail }));
}

export function subscribeEvent<K extends keyof PluginEventMap>(
    type: K,
    callback: (detail: PluginEventMap[K]) => void
): () => void {
    const handler = (event: Event) => {
        callback((event as CustomEvent<PluginEventMap[K]>).detail);
    };

    window.addEventListener(type, handler);
    return () => window.removeEventListener(type, handler);
}
